import { render, staticRenderFns } from "./blog-item.vue?vue&type=template&id=8aca079c&scoped=true&"
import script from "./blog-item.vue?vue&type=script&lang=js&"
export * from "./blog-item.vue?vue&type=script&lang=js&"
import style0 from "./blog-item.vue?vue&type=style&index=0&id=8aca079c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca079c",
  null
  
)

export default component.exports